import { render, staticRenderFns } from "./HeadView.vue?vue&type=template&id=612379c0&"
import script from "./HeadView.vue?vue&type=script&lang=js&"
export * from "./HeadView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports